import React from 'react';
import './CSS/Loading.css'; // Make sure to create this CSS file

const Spinner = () => {
    return (
        <div className="spinner-container">
            <div className="spinner"></div>
        </div>
    );
};

export default Spinner;
